import { AutoMap } from "@automapper/classes";
import { BusinessUnitDto } from "./business-unit.dto";

export class BusinessUnitResponseDto {

    @AutoMap()
  public content!: BusinessUnitDto[];

}